class ProductStitcher extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            productInfo: "[js-hb-main-product]",
            productReviews: "[js-product-review]",
            objectImageWithText: "[js-object-image-with-text]",
            objectTableColumn: "[js-object-table-column]",
            objectOverlayItem: "[js-object-overlay-item]",
            sizeGuide: "[js-size-guide]",
            stitcherItem: "[js-stitcher-item]"
        };
      
        this.sections = {
        
            mainProduct: { 
                element: document.querySelector(this.selectors.productInfo), 
                selector: this.selectors.productInfo, 
                initEvents: ["size-guide:init", "mainProductSectionMarquee:init"] 
            },
             productReviews: { 
                 element: document.querySelector(this.selectors.productReviews), 
                 selector: this.selectors.productReviews 
             },
             objectImageWithText: { 
                 element: document.querySelector(this.selectors.objectImageWithText), 
                 selector: this.selectors.objectImageWithText
             },
             objectTableColumn: { 
                 element: document.querySelector(this.selectors.objectTableColumn), 
                 selector: this.selectors.objectTableColumn
             },
             objectOverlayItem: { 
                 element: document.querySelector(this.selectors.objectOverlayItem), 
                 selector: this.selectors.objectOverlayItem
             },
             sizeGuide: { 
                 element: document.querySelector(this.selectors.sizeGuide), 
                 selector: this.selectors.sizeGuide,
                 initEvents: ["size-guide:init", "optiscroll:init"] 
             }
        };

        this.stitcherItems = this.querySelectorAll(this.selectors.stitcherItem);

        this.init();
    }

    init() {
        this.stitcherItems.forEach(stitcherItem =>
            stitcherItem.addEventListener("click", this.renderSectionFromFetch.bind(this))
        );
    }

    renderSectionFromFetch(evt) {
        evt.preventDefault();
        sessionStorage.setItem("hb-internal-product-nav", "1");
        const { currentTarget } = evt;
        const handle = currentTarget.getAttribute("data-product-handle");
        const variantsJson = JSON.parse(currentTarget.querySelector("[js-variants-json]").textContent);
        const current_variant = variantsJson.find( variant => variant.option1 === localStorage.getItem("selected-option"));

        this.updateLoading();
        Object.values(this.sections).forEach(({ element, selector, initEvents = [] }) => {
          
            element && this.renderSection(handle, element, selector, current_variant, ...initEvents);
        });
    }

    updateURLHash(handle) {
        const url = `/products/${handle}`;
        window.history.replaceState({}, '', url);
    }

    updateLoading() {
        this.sections.mainProduct.element.classList.add("section--loading");
    }

    renderSection(handle, container, selector, current_variant, ...initEvents) {
        const url = current_variant ? `/products/${handle}?variant=${current_variant.id}&section_id=${container.getAttribute("data-section")}` :  `/products/${handle}?section_id=${container.getAttribute("data-section")}`;
        this.ajaxSection(url, container, selector, handle, initEvents);
    }

    ajaxSection(url, container, selector, handle, initEvents = []) {
        fetch(url)
            .then(response => response.text())
            
            .then(html => {
                console.log("[product-stitcher] fetched section", { selector, handle, url });
                const ajaxContainer = new DOMParser()
                    .parseFromString(html, 'text/html')
                    .querySelector(selector);
                
                if (ajaxContainer) {
                    selector === this.selectors.productInfo 
                    ? container.outerHTML = ajaxContainer.outerHTML
                    : container.innerHTML = ajaxContainer.innerHTML
                }

                if(selector === this.selectors.productInfo) { 
                    console.log("[product-stitcher] swapped main product section", { handle });
                    window.Shopify.theme.sections.registered.product(document.querySelector('[data-section-type="product"]'));
                    document.querySelector("title").textContent = document.querySelector("[js-page-title]")?.getAttribute("data-page-title");
                  document.querySelector("meta[name='description']").content = document.querySelector("[js-page-title]")?.getAttribute("data-page-description");
                    timesactScriptNew(jQuery191)
                }

                initEvents.forEach(eventName => document.dispatchEvent(new CustomEvent(eventName)));
                selector === this.selectors.objectTableColumn || selector === this.selectors.sizeGuide ||  selector === this.selectors.objectImageWithText || selector === this.selectors.objectOverlayItem ;
                this.updateURLHash(handle);

                // yotpo can be blocked/absent; never break the flow.
                if (typeof yotpo !== "undefined" && yotpo?.initWidgets) {
                    selector === this.selectors.productReviews ? yotpo.initWidgets() : null;
                    selector === this.selectors.productInfo ? yotpo.initWidgets() : null;
                } else {
                    if (selector === this.selectors.productReviews || selector === this.selectors.productInfo) {
                        console.log("[product-stitcher] yotpo missing; skipped initWidgets", { selector });
                    }
                }

            })
            .catch(err => {
                console.log(err)
            })
    }
}

customElements.define('product-stitcher', ProductStitcher);

function getMainProductEl() {
    return document.querySelector("[js-hb-main-product]");
}

function getRedirectUrlFromSection() {
    const el = getMainProductEl();
    if (!el) return "";
    return (el.getAttribute("data-redirect-url") || "").trim();
}

function getRedirectProductsFromSection() {
    const el = getMainProductEl();
    if (!el) return new Set();

    const raw = (el.getAttribute("data-redirect-product") || "").trim();
    if (!raw) return new Set();

    // Accept comma-separated product handles and/or /products/<handle> URLs.
    const tokens = raw
        .split(",")
        .map(t => t.trim())
        .filter(Boolean);

    const handles = tokens.map(token => {
        const lower = token.toLowerCase();
        const match = lower.match(/\/products\/([^\/?#]+)/);
        return match ? match[1] : lower;
    });

    return new Set(handles);
}

function isRedirectExternalOnlyEnabled() {
    const el = getMainProductEl();
    if (!el) return true;
    const value = (el.getAttribute("data-redirect-external-only") || "").trim().toLowerCase();
    return value !== "false";
}

function getPaidTrafficParamsFromSection() {
    const el = getMainProductEl();
    const fallback = "utm_source,utm_medium,utm_campaign,gclid,fbclid,msclkid,ttclid";
    const raw = (el?.getAttribute("data-redirect-traffic-params") || fallback).trim();
    return raw
        .split(",")
        .map(p => p.trim().toLowerCase())
        .filter(Boolean);
}

function hasPaidTrafficParams() {
    const params = new URLSearchParams(window.location.search);
    return getPaidTrafficParamsFromSection().some(key => {
        const value = params.get(key);
        return value !== null && value !== "";
    });
}

function isExternalReferrer() {
    const referrer = document.referrer;
    if (!referrer) return false;

    try {
        const referrerHost = new URL(referrer).hostname.replace(/^www\./, "");
        const shopHost = window.location.hostname.replace(/^www\./, "");
        return referrerHost !== shopHost;
    } catch (e) {
        return false;
    }
}

function isInternalProductNavigation() {
    return sessionStorage.getItem("hb-internal-product-nav") === "1";
}

function shouldRedirectForTrafficSource(reason) {
    if (!isRedirectExternalOnlyEnabled()) return true;
    if (isInternalProductNavigation()) return false;
    if (reason !== "DOMContentLoaded" && reason !== "immediate") return false;

    return hasPaidTrafficParams() || isExternalReferrer();
}

function getCurrentProductJson() {
    const scope = getMainProductEl() || document;
    const script = scope.querySelector('script[type="application/json"][id^="ProductJson-"]');
    if (!script || !script.textContent) return null;
    try {
        return JSON.parse(script.textContent);
    } catch (e) {
        return null;
    }
}

function maybeRedirectUnavailableProduct(reason = "unknown") {
    const redirectUrl = getRedirectUrlFromSection();
    if (!redirectUrl) {
        console.log("[product-redirect] skip: empty redirect_url", { reason });
        return;
    }

    const product = getCurrentProductJson();
    const variants = product?.variants;
    if (!Array.isArray(variants) || variants.length === 0) {
        console.log("[product-redirect] skip: missing/empty variants", {
            reason,
            hasProduct: !!product,
            variantsType: typeof variants,
            redirectUrl
        });
        return;
    }

    const redirectProducts = getRedirectProductsFromSection();
    const currentHandle = (product?.handle || "").toLowerCase();
    if (redirectProducts.size > 0 && !redirectProducts.has(currentHandle)) {
        console.log("[product-redirect] skip: product not in allowlist", {
            reason,
            currentHandle,
            redirectProducts: Array.from(redirectProducts),
            redirectUrl
        });
        return;
    }

    if (!shouldRedirectForTrafficSource(reason)) {
        console.log("[product-redirect] skip: internal traffic", {
            reason,
            externalOnly: isRedirectExternalOnlyEnabled(),
            hasPaidParams: hasPaidTrafficParams(),
            paidParams: getPaidTrafficParamsFromSection(),
            isExternalReferrer: isExternalReferrer(),
            referrer: document.referrer,
            internalNav: isInternalProductNavigation()
        });
        return;
    }

    const allUnavailable = variants.every(v => !v?.available);
    console.log("[product-redirect] evaluated", {
        reason,
        handle: product?.handle,
        variantCount: variants.length,
        allUnavailable,
        redirectUrl,
        href: window.location.href
    });
    if (!allUnavailable) return;

    // Avoid infinite loops if redirect_url points to current page
    if (redirectUrl === window.location.href) return;
    if (redirectUrl === window.location.pathname || redirectUrl === window.location.pathname + window.location.search) return;

    console.log("[product-redirect] redirecting now", { reason, redirectUrl });
    window.location.assign(redirectUrl);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => maybeRedirectUnavailableProduct("DOMContentLoaded"));
} else {
    maybeRedirectUnavailableProduct("immediate");
}